import { Collection } from 'modules/core/lib/mobx-rest'

import Notifier from 'modules/automations/store/models/Notifier'

class NotifiersCollection extends Collection<Notifier> {
  model() {
    return Notifier
  }

  filterBySlug(str: string) {
    return this.filter((trigger: any) => trigger.matches(str))
  }
}

const notifiers: NotifiersCollection = new NotifiersCollection()

export default notifiers
